import React, { useState } from 'react';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [step, setStep] = useState(1); // 1 - email, 2 - code, 3 - new password
  const [formData, setFormData] = useState({
    email: '',
    code: ['', '', '', ''],
    newPassword: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Очищаем ошибку при изменении поля
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleCodeChange = (index, value) => {
    // Разрешаем только цифры
    if (!/^\d*$/.test(value)) return;
    
    const newCode = [...formData.code];
    newCode[index] = value;
    
    setFormData(prev => ({
      ...prev,
      code: newCode
    }));

    // Автоматический переход к следующему полю
    if (value && index < 3) {
      const nextInput = document.querySelector(`input[name="code-${index + 1}"]`);
      if (nextInput) {
        nextInput.focus();
      }
    }

    // Очищаем ошибку кода
    if (errors.code) {
      setErrors(prev => ({
        ...prev,
        code: ''
      }));
    }
  };

  const handleCodeKeyDown = (e, index) => {
    // Обработка Backspace
    if (e.key === 'Backspace' && !formData.code[index] && index > 0) {
      const prevInput = document.querySelector(`input[name="code-${index - 1}"]`);
      if (prevInput) {
        prevInput.focus();
      }
    }
  };

  const validateEmail = () => {
    const newErrors = {};
    
    if (!formData.email.trim()) {
      newErrors.email = 'Введите email';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Введите корректный email';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateCode = () => {
    const newErrors = {};
    
    const codeString = formData.code.join('');
    if (codeString.length !== 4) {
      newErrors.code = 'Введите полный код из 4 цифр';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validatePassword = () => {
    const newErrors = {};
    
    if (!formData.newPassword.trim()) {
      newErrors.newPassword = 'Введите новый пароль';
    } else if (formData.newPassword.length < 6) {
      newErrors.newPassword = 'Пароль должен содержать минимум 6 символов';
    }

    if (!formData.confirmPassword.trim()) {
      newErrors.confirmPassword = 'Повторите пароль';
    } else if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Пароли не совпадают';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    if (validateEmail()) {
      console.log('Отправка кода на email:', formData.email);
      setStep(2);
    }
  };

  const handleCodeSubmit = (e) => {
    e.preventDefault();
    if (validateCode()) {
      console.log('Проверка кода:', formData.code.join(''));
      // Здесь будет проверка кода
      setStep(3);
    }
  };

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    if (validatePassword()) {
      console.log('Изменение пароля:', formData.newPassword);
      // Здесь будет изменение пароля
      alert('Пароль успешно изменен!');
    }
  };

  const goBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  return (
    <div className="wrapper">
      <header data-fls-header-login="" data-fls-header-scroll="" className="header-login">
        <div className="header-login__container">
          <div className="header-login__body">
            <a href="/" className="header-login__logo">
              <img src="/assets/img/logo.svg" alt="Logo" />
            </a>
          </div>
        </div>
      </header>
      <main className="page auth">
        <div className="auth__container">
          <div className="auth__body forgot-password">
            
            {/* Этап 1: Ввод email */}
            {step === 1 && (
              <form data-fls-form="" action="#" method="#" data-fls-block="" className="forgot-password__content" onSubmit={handleEmailSubmit}>
                <h4 className="forgot-password__title forgot-password__title--title-25">Восстановление пароля</h4>
                
                <div className="forgot-password__field">
                  <input 
                    required 
                    data-fls-input="" 
                    autoComplete="off" 
                    type="email" 
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Введите ваш E-mail" 
                    className={`input ${errors.email ? '--form-error' : ''}`}
                  />
                  {errors.email && <div className="forgot-password__error">{errors.email}</div>}
                </div>

                <button type="submit" data-fls-button="" className="forgot-password__button button button--fw">
                  Восстановить пароль
                </button>
              </form>
            )}

            {/* Этап 2: Ввод кода */}
            {step === 2 && (
              <form data-fls-form="" action="#" method="#" data-fls-block="" className="forgot-password__content" onSubmit={handleCodeSubmit}>
                <h4 className="forgot-password__title forgot-password__title--title-25">Введите код из письма</h4>
                
                <div className="forgot-password__code-container">
                  {formData.code.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      name={`code-${index}`}
                      value={digit}
                      onChange={(e) => handleCodeChange(index, e.target.value)}
                      onKeyDown={(e) => handleCodeKeyDown(e, index)}
                      maxLength="1"
                      className={`forgot-password__code-input ${errors.code ? '--form-error' : ''}`}
                    />
                  ))}
                </div>
                {errors.code && <div className="forgot-password__error">{errors.code}</div>}

                <button type="submit" data-fls-button="" className="forgot-password__button button button--fw">
                  Восстановить
                </button>
              </form>
            )}

            {/* Этап 3: Новый пароль */}
            {step === 3 && (
              <form data-fls-form="" action="#" method="#" data-fls-block="" className="forgot-password__content" onSubmit={handlePasswordSubmit}>
                <h4 className="forgot-password__title forgot-password__title--title-25">Новый пароль</h4>
                
                <div className="forgot-password__field">
                  <input 
                    required 
                    data-fls-input="" 
                    autoComplete="off" 
                    type="password" 
                    name="newPassword"
                    value={formData.newPassword}
                    onChange={handleInputChange}
                    placeholder="Введите новый пароль" 
                    className={`input ${errors.newPassword ? '--form-error' : ''}`}
                  />
                  {errors.newPassword && <div className="forgot-password__error">{errors.newPassword}</div>}
                </div>

                <div className="forgot-password__field">
                  <input 
                    required 
                    data-fls-input="" 
                    autoComplete="off" 
                    type="password" 
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleInputChange}
                    placeholder="Повторите новый пароль" 
                    className={`input ${errors.confirmPassword ? '--form-error' : ''}`}
                  />
                  {errors.confirmPassword && <div className="forgot-password__error">{errors.confirmPassword}</div>}
                </div>

                <button type="submit" data-fls-button="" className="forgot-password__button button button--fw">
                  Изменить пароль
                </button>
              </form>
            )}

            {/* Кнопка "Назад" */}
            {step > 1 && (
              <button onClick={goBack} className="forgot-password__back">
                ← Назад
              </button>
            )}

            <a href="/login" className="forgot-password__login">Вернуться к входу</a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ForgotPassword;